import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checked\">\n<rect width=\"20\" height=\"20\" rx=\"10\" fill=\"#2F54EB\" />\n<path d=\"M8.88868 11.7612L13.9956 6.6543L14.7812 7.43997L8.88868 13.3325L5.35315 9.79701L6.13883 9.01134L8.88868 11.7612Z\" fill=\"white\" stroke=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol